import * as React from 'react';
import {GridRenderCellParams} from "@mui/x-data-grid";
import {Avatar, AvatarGroup} from '@mui/material';
import {getSellerNames, stringAvatar} from "@/helper/method";
import {isEmpty} from 'lodash';

type SellerAvatarType = {
    creator: string;
    seller: string;
}

export function SellerAvatar(params: GridRenderCellParams<any, SellerAvatarType, any>) {
    if (isEmpty(params.value)) {
        return '-';
    }
    const {creator, seller} = params.value;
    const names: string[] = getSellerNames(creator, seller, 2) as string[];
    return (
        <AvatarGroup sx={{
            '& .MuiAvatarGroup-avatar': {
                width: 32, height: 32, fontSize: 10, border: 'none'
            }
        }} max={3}>
            {names?.map((name: string, index: number) => <Avatar key={index} {...stringAvatar(name)} />)}
        </AvatarGroup>
    );
}